import { type ApplicationSettingNavbarButton, type ApplicationSettingNavbarLinkList, NavHandleEvent } from '@lighthouse/core'
import { nanoid } from '@lighthouse/tools'
import { find } from 'rambda'

import type { ApplicationNavbarHierarchyButton, ApplicationNavbarHierarchyLevelButton } from './types'

export const getInitBaseItem: () => ApplicationSettingNavbarButton = () => {
    const actionId = nanoid()
    return {
        id: '',
        name: '',
        showType: 'icon-name',
        events: {
            handleEvent: NavHandleEvent.OPEN_PAGE,
            triggerEvent: 'click',
            params: ['']
        },
        // 类型兼容处理，后续会去掉 events
        action: {
            id: actionId,
            type: 'none',
            trigger: 'click',
            data: {
                none: {}
            }
        },
        child: []
    }
}

export const getAllChild = (list: string[], id: string, dataList: ApplicationSettingNavbarLinkList) => {
    const { child = [] } = dataList.list[id]
    let arrList = [...list, id]
    for (const nodeId of child) {
        arrList = getAllChild(arrList, nodeId, dataList)
    }
    return arrList
}

export const getNodeLevel = (id: string, list: Record<string, ApplicationSettingNavbarButton>, level = 0) => {
    const { parentId = '' } = list[id]
    let currentLevel = level
    if (parentId) {
        currentLevel = getNodeLevel(parentId, list, level + 1)
    }
    return currentLevel
}

const getFlapChidList = (
    childList: string[],
    dataList: Record<string, ApplicationSettingNavbarButton>,
    curList: ApplicationNavbarHierarchyLevelButton[]
) => {
    let arrList = curList
    for (const nodeId of childList) {
        const node = dataList[nodeId]
        arrList = getFlapChidList(node.child ?? [], dataList, [...arrList, { ...node, level: getNodeLevel(node.id, dataList) }])
    }
    return arrList
}

export const getFlapList = (dataList: ApplicationSettingNavbarLinkList): ApplicationNavbarHierarchyLevelButton[] => {
    let arrList: ApplicationNavbarHierarchyLevelButton[] = []
    for (const nodeId of dataList.child) {
        const node = dataList.list[nodeId]
        const childNodeList = getFlapChidList(node.child ?? [], dataList.list, [{ ...node, level: 0 }])
        arrList = [...arrList, ...childNodeList]
    }
    return arrList
}

const getParentNodeIdList = (
    list: ApplicationNavbarHierarchyLevelButton[],
    id: string,
    nodes?: ApplicationNavbarHierarchyLevelButton[]
): ApplicationNavbarHierarchyLevelButton[] => {
    const node = find(item => item.id === id, list)
    const { parentId } = node ?? {}
    const parentNode = find(item => item.parentId === parentId, list)
    let currentNodes = node ? [...(nodes ?? []), node] : nodes ?? []
    if (parentNode && parentId) {
        currentNodes = getParentNodeIdList(list, parentId, currentNodes)
    }
    return currentNodes
}

// 返回一个具有层级关系的 ApplicationNavbarHierarchyButton
const getNodeHierarchyList = (data: ApplicationSettingNavbarButton, dataList: ApplicationSettingNavbarLinkList, level: number) => {
    const { child = [] } = data
    const newData: ApplicationNavbarHierarchyButton = { ...data, child: [] }
    for (const nodeId of child) {
        const newChild = getNodeHierarchyList(dataList.list[nodeId], dataList, level + 1)
        newData.child.push(newChild)
    }
    return newData
}

// 返回一个具有层级关系的 ApplicationNavbarHierarchyButton数组
export const getAllNodeHierarchyList = (dataList: ApplicationSettingNavbarLinkList): ApplicationNavbarHierarchyButton[] => {
    const { child = [], list: linkMapList } = dataList
    const newData: ApplicationNavbarHierarchyButton[] = []
    for (const nodeId of child) {
        newData.push(getNodeHierarchyList(linkMapList[nodeId], dataList, 0))
    }
    return newData
}
